import React from 'react'
import { useTranslation } from 'react-i18next'

import s from './ErrorTooltip.module.scss'

export default function ErrorTooltip() {
  const { t } = useTranslation()

  return (
    <div className={s['error-tooltip']}>
      <div className={s.text} dangerouslySetInnerHTML={{ __html: t('hint.clubOne.error') }} />
    </div>
  )
}
